const k = () => window.klaviyo;

const SITE = "https://farmacydistrictdc.com";

export const klaviyoIdentify = (email, fullName = "") => {
  const lib = k();
  if (!lib || !email) return;
  const parts = (fullName || "").trim().split(/\s+/).filter(Boolean);
  lib.identify({
    email: email.trim().toLowerCase(),
    ...(parts[0] ? { first_name: parts[0] } : {}),
    ...(parts.length > 1 ? { last_name: parts.slice(1).join(" ") } : {}),
  });
};

const itemOf = (p, qty, unitPrice, optionLabel) => ({
  ProductID: String(p.product_id ?? p.ProductID ?? ""),
  SKU: p.sku || "",
  ProductName: (p.name || "Item") + (optionLabel ? ` (${optionLabel})` : ""),
  Quantity: qty,
  ItemPrice: unitPrice,
  RowTotal: Math.round(unitPrice * qty * 100) / 100,
  ProductURL: p.slug ? `${SITE}/product/${p.slug}` : SITE,
  ImageURL: p.image || "",
  ProductCategories: p.categories || [],
});

export const klaviyoViewedProduct = (p) => {
  const lib = k();
  if (!lib || !p) return;
  const price = Number(p.price || p.from_price || 0);
  const item = {
    ProductName: p.name,
    ProductID: String(p.product_id),
    SKU: p.sku || "",
    Categories: p.categories || [],
    ImageURL: p.image || "",
    URL: `${SITE}/product/${p.slug}`,
    Brand: "Farmacy District DC",
    Price: price,
    CompareAtPrice: Number(p.compare_at || price),
  };
  lib.track("Viewed Product", item);
  if (typeof lib.trackViewedItem === "function") {
    lib.trackViewedItem({
      Title: item.ProductName,
      ItemId: item.ProductID,
      Categories: item.Categories,
      ImageUrl: item.ImageURL,
      Url: item.URL,
      Metadata: { Brand: item.Brand, Price: item.Price, CompareAtPrice: item.CompareAtPrice },
    });
  }
};

export const klaviyoAddedToCart = (p, qty, optionLabel, unitPrice, cartItems, cartTotal) => {
  const lib = k();
  if (!lib) return;
  lib.track("Added to Cart", {
    $value: cartTotal,
    AddedItemProductName: p.name,
    AddedItemProductID: String(p.product_id),
    AddedItemSKU: p.sku || "",
    AddedItemCategories: p.categories || [],
    AddedItemImageURL: p.image || "",
    AddedItemURL: p.slug ? `${SITE}/product/${p.slug}` : SITE,
    AddedItemPrice: unitPrice,
    AddedItemQuantity: qty,
    ItemNames: cartItems.map((i) => i.name),
    CheckoutURL: `${SITE}/checkout`,
    Items: cartItems.map((i) => itemOf(i, i.qty, i.unit_price, i.option)),
  });
};

export const klaviyoStartedCheckout = (cartId, cartItems, total) => {
  const lib = k();
  if (!lib) return;
  lib.track("Started Checkout", {
    $event_id: `${cartId || "cart"}_${Date.now()}`,
    $value: total,
    ItemNames: cartItems.map((i) => i.name),
    CheckoutURL: `${SITE}/checkout`,
    Categories: [...new Set(cartItems.flatMap((i) => i.categories || []))],
    Items: cartItems.map((i) => itemOf(i, i.qty, i.unit_price, i.option)),
  });
};
